var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 0.0816285C10.9397 0.49767 9.82777 1.27182 8.99874 1.94592C7.03562 3.53372 5.39968 5.46911 4.21394 7.60725L4.0196 7.96009L3.95563 7.87056C3.79327 7.63885 3.53989 7.3571 3.3234 7.16224C2.4673 6.39335 1.32584 5.83775 0.231117 5.65343C0.0859742 5.62973 -0.0247281 5.72979 0.00479252 5.85618C0.0121727 5.88778 0.110575 5.99048 0.221277 6.08264C0.949452 6.68827 1.75389 7.72574 2.45992 8.97913C2.83631 9.64533 3.4218 10.8487 3.77113 11.6702C3.86461 11.8888 3.90643 11.9599 3.95563 11.981C4.08602 12.0389 4.12538 11.9889 4.34678 11.4859C5.66783 8.48936 7.39478 5.57443 9.19308 3.29147C9.89666 2.40146 10.8758 1.31659 11.5695 0.660927C11.9656 0.287016 12 0.250152 12 0.179056C12 0.121126 11.8967 5.93898e-08 11.845 5.93898e-08C11.8253 5.93898e-08 11.7442 0.0368645 11.6654 0.0816285Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d9ee1665b00c0492eacba917b7e33433.svg";
export { ForwardRef as ReactComponent };